import { Request } from '../../index'

export type ParallelsListParams = {
  schoolId: string
  schoolYearId: string
}

export type ParallelsList = number[]

type ParallelsListApiParams = {
  school_id: number
  schoolyear_id: number
}

type ParallelsListApiResult = number[]

export const convertParams = (params: ParallelsListParams): [ParallelsListApiParams, null] => {
  const { schoolId, schoolYearId } = params

  return [
    {
      school_id: parseInt(schoolId, 10),
      schoolyear_id: parseInt(schoolYearId, 10),
    },
    null,
  ]
}

export const convertResult = (apiData: ParallelsListApiResult): ParallelsList => apiData

export const GET_PARALLELS_LIST: Request<ParallelsListParams, ParallelsList, void> = [
  'reports/parallels_list',
  'get',
  ['data', 'parallels'],
]
